import { __rest } from '../../_virtual/_tslib.js';
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/checkbox.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import * as reactUtils from '../../packages/react-utils/react-utils.js';
import * as propsUtils from '../../packages/props-utils/props-utils.js';
import { InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import { InputInfoChildren, InputInfo } from '../_atoms/input-info/input-info.js';
import { inputLabelValidator } from '../../prop-types-validators/input-label-validator.js';
import '../_atoms/inline-label/inline-label.js';
import { InputField } from '../_atoms/input-field/input-field.js';
import '../_atoms/nav-elem/nav-elem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('checkbox', styles);
function Checkbox(_a) {
  var {
      id,
      extraClasses,
      label,
      value,
      disabled,
      valid,
      innerRef,
      info,
      infoError,
      small = false,
      indeterminate = false,
      'aria-describedby': ariaDescribedBy
    } = _a,
    rest = __rest(_a, ["id", "extraClasses", "label", "value", "disabled", "valid", "innerRef", "info", "infoError", "small", "indeterminate", 'aria-describedby']);
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, []);
  const className = bem.b({
    disabled,
    error: valid === false,
    sm: small,
    indeterminate,
    'no-label': !label
  }, extraClasses);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(InputField, Object.assign({
    ref: node => {
      reactUtils.assignInnerRefWithComponentRef(node, innerRef, inputRef);
    },
    id: id,
    type: "checkbox",
    value: value,
    disabled: disabled,
    className: bem.e('input'),
    valid: valid,
    "aria-errormessage": "infoError-".concat(id),
    "aria-describedby": propsUtils.handleAriaDescribedBy(id, {
      info,
      ariaDescribedBy
    })
  }, rest)), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: bem.e('label')
  }, label), /*#__PURE__*/React.createElement(InputInfo, {
    error: true,
    id: id,
    className: bem.e('info')
  }, valid === false ? infoError : ''), info && (/*#__PURE__*/React.createElement(InputInfo, {
    id: id,
    className: bem.e('info')
  }, info)));
}
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  extraClasses: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: inputLabelValidator('Checkbox'),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
  innerRef: InnerRefPropType,
  info: InputInfoChildren,
  infoError: InputInfoChildren,
  small: PropTypes.bool,
  indeterminate: PropTypes.bool
};
var Checkbox$1 = Injecss(Checkbox, styles);

export { Checkbox, Checkbox$1 as default };
